import React, { FC } from 'react';

interface ILogoProps {
	width?: number;
	height?: number;
	alt?: string;
}

const aspectRatio = 2155 / 854;

const Logo: FC<ILogoProps> = ({ width = 2155, height }) => {
	let computedWidth = width;
	let computedHeight = height || Math.round(width / aspectRatio);

	if (height && !width) {
		computedHeight = height;
		computedWidth = Math.round(height * aspectRatio);
	}

	return (
		<img
			src='/logo-light.svg'
			alt='Recity'
			width={computedWidth}
			height={computedHeight}
			style={{
				width: computedWidth,
				height: computedHeight,
				objectFit: 'contain',
			}}
		/>
	);
};

export default Logo;
